<template>
  <div>
    <p class="title" :class="{'has-text-white': white}">Asleep Time
      <span class="icon">
        <i v-if="loading" class="fas fa-circle-notch fa-spin"></i>
      </span>
    </p>
    <p class="subtitle" :class="{'has-text-white': white}">
      Edit how long a tracker is asleep
      <br />Tracker:
      <select v-model="trackerId" :disabled="loading" @change="getSleepTime()">
        <option
          v-for="tracker in user.trackers"
          :key="tracker"
          :value="tracker"
        >{{tracker}}</option>
      </select>
      <br />Sleeptime:
      <select v-model="time" :disabled="loading" @change="updateSleeptime()">
        <option
          v-for="option in options"
          :key="option.value"
          :value="option.value"
        >{{option.name}}</option>
      </select>
    </p>
    <p class="help is-danger" v-if="error">{{error}}</p>
  </div>
</template>

<script>
export default {
  data: () => {
    return {
      time: '',
      trackerId: '',
      options: sleepOptions,
      loading: false,
      error: null
    }
  },
  props: {
    white: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    user () {
      return this.$store.state.user
    }
  },
  methods: {
    async updateSleeptime () {
      if (!this.trackerId || !this.time) {
        this.error = 'No tracker or sleeptime set'
        return
      }
      this.loading = true
      this.error = null
      const result = await this.$store.dispatch('setSleepTime', { sleepTime: this.time, trackerId: this.trackerId })
      if (result.error) this.error = result.message
      this.loading = false
    },
    async getSleepTime () {
      if (!this.trackerId) return
      this.loading = true
      this.error = null
      const result = await this.$store.dispatch('getSleepTime', this.trackerId)
      if (result.error) this.error = result.message
      else this.time = result.sleepTime
      this.loading = false
    },
    setFirstTracker () {
      if (this.user.trackers.length !== 0) this.trackerId = this.user.trackers[0]
      this.getSleepTime()
    }
  },
  async created () {
    this.error = await this.$store.dispatch('getUser')
    this.setFirstTracker()
  }
}
const sleepOptions = [{
  name: '1 minute',
  value: 'SUCCESSM1'
}, {
  name: '5 minutes',
  value: 'SUCCESSM5'
}, {
  name: '10 minutes',
  value: 'SUCCESSM10'
}, {
  name: '20 minutes',
  value: 'SUCCESSM20'
}, {
  name: '30 minutes',
  value: 'SUCCESSM30'
}, {
  name: '45 minutes',
  value: 'SUCCESSM45'
}, {
  name: '1 hour',
  value: 'SUCCESSH1'
}, {
  name: '2 hours',
  value: 'SUCCESSH2'
}, {
  name: '3 hours',
  value: 'SUCCESSH3'
}, {
  name: '5 hours',
  value: 'SUCCESSH5'
}, {
  name: '8 hours',
  value: 'SUCCESSH8'
}, {
  name: '1 day',
  value: 'SUCCESSD1'
}, {
  name: '2 days',
  value: 'SUCCESSD2'
}, {
  name: 'Active tracking',
  value: 'SUCCESSACTIVE'
}]
</script>

<style scoped>
.button {
  margin-top: 1em;
}
</style>
